export default {
  data() {
    return {
      loaded: false
    };
  },
  computed: {
    authenticated() {
      return this.$store.getters.authenticated;
    }
  },
  mounted() {
    //  [App.vue specific] When App.vue is finish loading finish the progress bar
    this.$Progress.finish();
    setTimeout(() => {
      if (this.authenticated) {
        this.loaded = true;
      }
    }, 3 * 1000); // tunda 3 detik
  },

  created() {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start();
    //  hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        const meta = to.meta.progress;
        // parse meta tags
        this.$Progress.parseMeta(meta);
      }
      //  start the progress bar
      this.$Progress.start();
      //  continue to next page
      next();
    });
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach(() => {
      //  finish the progress bar
      setTimeout(() => {
        this.$Progress.finish();
      }, 1000);
    });
  }
};